import React from "react";
import "./Carousel.scss";
import { useState } from "react";
import { carouselItem } from "../../types/carouselInterface";
import arrowLeft from "../../assets/icons/circleArrowLeft.svg";
import arrowRight from "../../assets/icons/circleArrowRight.svg";

interface CarouselProps {
  items: carouselItem[];
}

const Carousel: React.FC<CarouselProps> = ({ items }) => {
  const [slide, setSlide] = useState<number>(0);
  const [touchPosition, setTouchPosition] = useState<number | null>(null);

  const nextSlide = () => {
    setSlide(slide === items.length - 1 ? 0 : slide + 1);
  };

  const prevSlide = () => {
    setSlide(slide === 0 ? items.length - 1 : slide - 1);
  };

  const handleTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
    const touchDown = e.touches[0].clientX;
    setTouchPosition(touchDown);
  };

  const handleTouchMove = (e: React.TouchEvent<HTMLDivElement>) => {
    const touchDown = touchPosition;

    if (touchDown === null) {
      return;
    }

    const currentTouch = e.touches[0].clientX;
    const diff = touchDown - currentTouch;

    if (diff > 5) {
      nextSlide();
    }

    if (diff < -5) {
      prevSlide();
    }

    setTouchPosition(null);
  };

  return (
    <div
      className="carousel"
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
    >
      <span
        onClick={prevSlide}
        className="carousel__arrows carousel__arrows--left"
      >
        <img src={arrowLeft} alt="Left Carousel Arrow" />
      </span>
      {items.map((item, i) => {
        return (
          <img
            src={item.cImg}
            alt={item.cAlt}
            key={i}
            className={
              slide === i
                ? "carousel__slide"
                : "carousel__slide carousel__slide--hidden"
            }
          />
        );
      })}
      <span
        onClick={nextSlide}
        className="carousel__arrows carousel__arrows--right"
      >
        <img src={arrowRight} alt="Right Carousel Arrow" />
      </span>
      <span className="carousel__indicators">
        {items.map((_, i) => {
          return (
            <button
              key={i}
              className={
                slide === i
                  ? "carousel__indicator"
                  : "carousel__indicator carousel__indicator--inactive"
              }
              onClick={() => setSlide(i)}
            ></button>
          );
        })}
      </span>
    </div>
  );
};

export default Carousel;
